import { useState } from "react";
import { Box, Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import { PendingReviewItem } from "@/domain/eventInstance.interface";
import { PendingQueueTable } from "./PendingQueueTable";
import { ReviewModal } from "./ReviewModal";

type TabValue = "pending" | "history";

const ReviewQueuePage = () => {
	const [tab, setTab] = useState<TabValue>("pending");
	const [active, setActive] = useState<PendingReviewItem | null>(null);

	return (
		<Box sx={{ p: 3 }}>
			<Stack spacing={2}>
				<Typography variant="h5">Review Queue</Typography>
				<Paper variant="outlined">
					<Tabs
						value={tab}
						onChange={(_, v: TabValue) => setTab(v)}
						sx={{ borderBottom: 1, borderColor: "divider" }}
					>
						<Tab label="Pending" value="pending" />
						<Tab label="History" value="history" />
					</Tabs>
					<Box sx={{ p: 2 }}>
						{tab === "pending" && <PendingQueueTable onReview={setActive} />}
						{tab === "history" && (
							<Box
								sx={{
									py: 6,
									textAlign: "center",
									color: "text.secondary",
								}}
							>
								<Typography variant="body2">
									Review history listing — coming next.
								</Typography>
							</Box>
						)}
					</Box>
				</Paper>
			</Stack>

			<ReviewModal
				open={Boolean(active)}
				enrollmentId={active?.enrollmentId}
				instanceId={active?.instanceId}
				onClose={() => setActive(null)}
			/>
		</Box>
	);
};

export default ReviewQueuePage;
